module.exports = __webpack_public_path__ + "static/media/lock.de8120e7.svg";